export enum HomeCenterType {
  Clayton,
  Independent,
  Community,
}
